module.exports = __webpack_public_path__ + "static/img/pair-vscode.29462098.svg";